import { VfModal } from '@vfit/shared/components';
import { useState } from 'react';
import * as S from './detailsChecklist.style';
import { Svg } from '@vfit/shared/atoms';
import { purify } from '@vfit/shared/themes';
import { trackLink } from '@vfit/shared/data-access';

export const DetailsChecklist = ({ checkList }: IDetailsChecklist) => {
  return (
    <>
      {checkList &&
        checkList.map((option) => (
          <ListElement
            optionText={option.optionText}
            optionMoreDetails={option.optionMoreDetails}
          />
        ))}
    </>
  );
};

const ListElement = ({ optionText, optionMoreDetails }: Option) => {
  const [isOpenModal, setOpenModal] = useState(false);
  const purifyElement = (text: string) => {
    return purify([text]);
  };
  const optionTextHtml = purifyElement(optionText || '')?.[0] || '';

  const purifyRawHtml = (rawHTML: string) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(rawHTML, 'text/html');
    doc.querySelectorAll('[style]').forEach((el) => {
      if (el.tagName.toLowerCase() !== 'span') {
        el.removeAttribute('style');
      }
    });
    doc.querySelectorAll('br').forEach((el) => {
      el.replaceWith(document.createTextNode(' '));
    });
    doc.querySelectorAll('p').forEach((el) => {
      const fragment = document.createDocumentFragment();
      while (el.firstChild) {
        fragment.appendChild(el.firstChild);
      }
      el.replaceWith(fragment);
    });
    return doc.body?.innerHTML || '';
  };

  return (
    <S.ListElement>
      <S.CheckMark>
        <Svg name={'tickV2'} height={30} width={18} />{' '}
      </S.CheckMark>
      <S.OptionText dangerouslySetInnerHTML={{ __html: optionTextHtml }} />
      {optionMoreDetails && (
        <>
          <S.CircleSmall
            onClick={() => {
              trackLink(purifyRawHtml(optionTextHtml || ''));
              setOpenModal(true);
            }}
          >
            <Svg name="info" height={16} width={16} />
          </S.CircleSmall>
          <VfModal isOpen={isOpenModal} handleClose={() => setOpenModal(false)}>
            <div
              dangerouslySetInnerHTML={{
                __html: purifyElement(optionMoreDetails || '')?.[0] || '',
              }}
            />
          </VfModal>
        </>
      )}
    </S.ListElement>
  );
};

type IDetailsChecklist = {
  checkList: Option[];
};
type Option = {
  optionText?: string;
  optionMoreDetails?: string;
};
